export default __webpack_public_path__ + "static/sanjayRakesh-e361e3274963078769cabdaca7a436da.jpg";